import { TAnalyticsMessagePayload } from '../../types';
import { normalizePage } from './utils';
import { trackAddFavorite, trackClickCard, trackDeleteFavorite, trackShowNumberClick } from './analytics';

export function eventSiteHandler([, eventParams]: TAnalyticsMessagePayload, pageRaw: unknown) {
  const { action, category, label, sc, products } = eventParams;

  const page = normalizePage(pageRaw);

  switch (true) {
    case category === 'favorite' && action === 'add_from_list_mob':
      trackAddFavorite({ label, sc, products, page });
      break;
    case category === 'favorite' && action === 'remove_from_list_mob':
      trackDeleteFavorite({ label, sc, products, page });
      break;
    case category === 'Listing' && action === 'to_card':
      trackClickCard({ sc, products, page });
      break;
    case category === 'Phones' && action === 'Open_listing':
      trackShowNumberClick({ label, sc, products, page });
      break;
  }
}
